<template>
	<div class="container">
		<div class="main_box">
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="200"
				data-aos-offset="0"
				data-aos-once="true"
				class="title"
			>Abiores</div>
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="txt">
					Abiores is a subsidiary of Cordx Union (CU), a multinational group corporation well known for R&D, manufacture and marketing of medical devices, headquartered in California, USA. Based on the headquarters in the US, manufacturing bases in China and global business divisions, the group consists of a number of subsidiaries, namely, Coretests Inc., Core Technology, Jtests LLC, Abiores, Bonore Industry, Core Medical, Core Investment, Bao Ruiyuan Biotech, Abiores Technology, Abiores Holding, Abiores Consulting, etc.
				</div>
				<div class="btn" @click="goContact">
					Contact Us&ensp;<van-icon name="down" size="12px" color="#C8000A" style="top: 2px;transform: rotate(-90deg);" />
				</div>
				<img src="../../../assets/img_public/about/block1.webp" />
				<div class="txt">
				Abiores is a high-tech enterprise specializing in the R&D, production, sales and technical services of in vitro diagnostic (IVD) products. Among its production bases in China, the Fangshan production base located in Bao Ruiyuan Industrial Park, Doudian town, Fangshan District, Beijing, covers an area of 4 hectares and a construction area of more than 30,000 m².The company has an independent R&D center, quality inspection center and GMP plants of grade 100,000 and grade 10,000 (local grade 100) standards, with full sets of molecular diagnostic reagent production lines and corresponding supporting facilities.
				</div>
				<div class="txt">
				Abiores now owns Magnetic Beads Technology Platform, Micro Nucleic Acid Releasing Reagent Platform (One-tube Method) and Automated Nucleic Acid Extraction Platform, and has developed fluorescence PCR products for Hepatitis B, Hepatitis C, HIV, hand, foot and mouth disease and respiratory diseases, etc.
				</div>
				<div class="txt">
				Adhering to its quality policy of “Perfect Quality, Sincere Service, Standardized Management, Exploration and Innovation” and the aim of creating a first-class biomedical enterprise, Abiores will continuously improve its R&D capacity and production technology level, and make full use of the research achievements in the fields of molecular biology, modern bioengineering technology and biomedicine to provide customers with high-quality products and technical services and serve the cause of human health!
				</div>
				<img src="../../../assets/img_public/about/block2.webp" />
				<div class="txt">
					Abiores regards its talents as the foundation of the company and the source of profits. It actively introduces high-tech talents both from home and abroad, and attaches importance to the on-the-job training and the improvement of personal value of its employees. Welcome to join us!
				</div>
				<div class="btn" @click="goCorDx">
					About CorDx&ensp;<van-icon name="down" size="12px" color="#C8000A" style="top: 2px;transform: rotate(-90deg);" />
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转联系我们
		goContact() {
			let that = this;
			that.$router.push({ path: '/contact.html' });
		},
		//跳转官网
		goCorDx() {
			window.location.href = 'https://cordx.com/about';
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		padding: 0 16px 40px 16px;
		img{
			width: 100%;
			margin: 30px 0;
		}
		.btn{
			display: inline-block;
			margin-top: 10px;
			color: #C8000A;
			font-size: 12px;
		}
		.txt{
			line-height: 2;
			text-indent: 0px;
		}
	}
	.title{
		padding: 0px 0 30px 0;
		font-size: 24px;
		font-weight: bold;
		text-align: center;
	}
}
</style>